export default "__VITE_ASSET__DdEkP_y0__"